var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6C4.9 2 4 2.9 4 4V11C3.448 11 3 11.448 3 12V17C3 17.552 3.448 18 4 18V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM5 13H6V14H5V13ZM5 16V15H6V16H5ZM18 20H6V18H15C15.552 18 16 17.552 16 17V12C16 11.448 15.552 11 15 11H6V4H13V9H18V20ZM8 15V16H7V15H8ZM7 14V13H8V14H7ZM10 15V16H9V15H10ZM9 14V13H10V14H9ZM12 15V16H11V15H12ZM11 14V13H12V14H11ZM14 15V16H13V15H14ZM13 14V13H14V14H13Z",
    fill: "#107C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadXls);
export default __webpack_public_path__ + "static/media/icon-upload-xls.f8cafaa666f888855c64f2112398e59b.svg";
export { ForwardRef as ReactComponent };